import { z } from 'zod';
const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/;
export const scheduleEntrySchema = z.object({
    weekType: z.enum(['A', 'B']),
    dayOfWeek: z.number().int().min(1).max(7),
    isWorkday: z.boolean(),
    location: z.enum(['kantoor', 'thuis']).optional().nullable(),
    isHalfDay: z.boolean().optional().default(false),
    halfDayPeriod: z.enum(['ochtend', 'middag']).optional().nullable(),
    startTime: z.string().regex(timePattern, 'Ongeldig tijdsformaat (HH:mm)').optional().nullable(),
    endTime: z.string().regex(timePattern, 'Ongeldig tijdsformaat (HH:mm)').optional().nullable(),
}).refine(data => {
    // Werkdag vereist locatie
    if (data.isWorkday && !data.location)
        return false;
    return true;
}, { message: 'Werkdag vereist een locatie (kantoor of thuis)' })
    .refine(data => {
    // Halve dag vereist period
    if (data.isHalfDay && !data.halfDayPeriod)
        return false;
    return true;
}, { message: 'Halve dag vereist een periode (ochtend of middag)' })
    .refine(data => {
    // Eindtijd moet na starttijd liggen
    if (data.startTime && data.endTime && data.startTime >= data.endTime)
        return false;
    return true;
}, { message: 'Eindtijd moet na starttijd liggen' });
export const upsertScheduleSchema = z.object({
    entries: z.array(scheduleEntrySchema).min(1, 'Minimaal 1 entry vereist').max(14, 'Maximaal 14 entries (7 dagen × 2 weken)'),
});
//# sourceMappingURL=workSchedule.js.map